import Vue from "vue";

// local state
const getDefaultState = () => {
  return {
    values: {},
    articleImageUrl: "",
    articleDatasheetUrl: "",
    selectUrl: "",
  };
};

const state = getDefaultState();

const getters = {};

const mutations = {
  updateValues(state, values) {
    state.values = values;
  },
  updateArticleImageUrl(state, value) {
    state.articleImageUrl = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetState({commit}) {
    commit("resetState");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
